import { Crisp } from "crisp-sdk-web";

export default defineNuxtPlugin((_) => {
  const websiteId = useRuntimeConfig().public.crispWebsiteId;

  Crisp.configure(websiteId, {
    safeMode: true,
  });

  function setUserData(id: string, email?: string, plan?: string) {
    Crisp?.setTokenId(id);
    if (email)
      Crisp?.user?.setEmail(email);
    Crisp?.session?.setData({
      id,
      plan,
    });
  }

  function openChat() {
    Crisp?.chat?.open();
  }

  function hideChat() {
    Crisp?.chat?.hide();
  }

  function resetUserData() {
    Crisp?.session?.reset();
  }

  return {
    provide: {
      crisp: {
        setUserData,
        openChat,
        hideChat,
        resetUserData,
      },
    },
  };
});
